import { render, staticRenderFns } from "./appointList.vue?vue&type=template&id=4b43bd16&scoped=true&"
import script from "./appointList.vue?vue&type=script&lang=js&"
export * from "./appointList.vue?vue&type=script&lang=js&"
import style0 from "./appointList.vue?vue&type=style&index=0&id=4b43bd16&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b43bd16",
  null
  
)

export default component.exports